import { render, staticRenderFns } from "./PatientManagement.vue?vue&type=template&id=67388726&scoped=true"
import script from "./PatientManagement.vue?vue&type=script&lang=js"
export * from "./PatientManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67388726",
  null
  
)

export default component.exports